import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import getTwitterShareUrl from '../../utils/tweet/tweetShare';
import { isPortrait } from '../../utils/size';

const Button = styled.button`
    flex: 1;
    height: ${props => (props.isMultiDonation && !isPortrait() ? 56 : 70)}px;
    border-radius: 4px;
    border: solid 1px #f1f1ee;
    text-transform: uppercase;
    margin: 0 9px;
    cursor: pointer;
    background-color: #fff;
    position: relative;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 1);

    &:focus {
        outline: none;
    }

    @media (min-width: 30em) {
        &:hover {
            background-color: #ff245e;
            border: solid 1px #ff245e;
            color: #fff;
        }
    }

    @media (min-width: 30em) {
        &:hover span {
            color: #fff;
        }
    }

    @media (max-width: 30em) {
        margin: 0 0 12px;
        min-height: 70px;
        max-height: 70px;
    }

    &.clicked {
        @media (max-width: 30em) {
            background-color: #ff245e;
            border: solid 1px #ff245e;
            color: #fff;

            span {
                color: #fff;
            }
        }
    }
`;

const Text = styled.span`
    font-family: Averta;
    font-size: 24px;
    font-weight: 600;
    letter-spacing: 2px;
    text-align: center;
    color: #333;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    position: absolute;
    left: 0;
    width: 100%;
    line-height: 100%;
`;

const MultiActionsCardAction = props =>
    props.action.type === 'tweet' &&
    ((props.localRepFound && props.showTwitterPopUp) ||
        (!props.localRepFound && !props.action.useLocalRepresentative)) ? (
        <Button
            isMultiDonation={props.isMultiDonation}
            data-action={props.action.identifier}
            onClick={() => {
                window.open(
                    getTwitterShareUrl(
                        props.tweetContent,
                        props.localRepTwitterMention,
                        props.localRepPostalCode,
                        props.partnerName,
                        props.publisherName,
                        props.articleUrl
                    ),
                    'popup',
                    'height=350,width=600'
                );
                props.onClick();
            }}
        >
            <Text>{props.label}</Text>
        </Button>
    ) : (
        <Button
            isMultiDonation={props.isMultiDonation}
            data-action={props.action.identifier}
            onClick={props.onClick}
        >
            <Text>{props.label}</Text>
        </Button>
    );

MultiActionsCardAction.propTypes = {
    action: PropTypes.object.isRequired,
    articleUrl: PropTypes.string,
    tweetContent: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    localRepFound: PropTypes.bool.isRequired,
    localRepTwitterMention: PropTypes.string,
    localRepPostalCode: PropTypes.string,
    showTwitterPopUp: PropTypes.bool.isRequired,
    isMultiDonation: PropTypes.bool.isRequired,
    partnerName: PropTypes.string,
    publisherName: PropTypes.string,
    label: PropTypes.string
};

export default MultiActionsCardAction;
